import { ROUTING_MEASURES } from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const DeadEndChatsQuery: CubeQuery = {
  name: 'DeadEndChats',
  query: {
    measures: [ROUTING_MEASURES.ROUTING_COUNT, ROUTING_MEASURES.DEAD_END_COUNT],
  },
  queryName: ROUTING_MEASURES.DEAD_END_COUNT,
}
